// extracted by mini-css-extract-plugin
module.exports = {"tabRoot":"Tab_tabRoot__t07yq","tabItem":"Tab_tabItem__jRvq9"};